// FAT-33: configuração central das URLs de API. O front só fala com o backend próprio.
// REACT_APP_API_BASE troca a base (padrão relativo '/api'); nunca um host externo fixo no código.
export const API_BASE = (process.env.REACT_APP_API_BASE || '/api').replace(/\/+$/, '');

export const apiUrl = (caminho = '') => `${API_BASE}${caminho.startsWith('/') ? '' : '/'}${caminho}`;

// Fontes que ficavam em api.fatcat.app.br / data.fatcat.app.br e não têm equivalente no backend:
// a chamada foi removida. Rejeita sem sair do app; as telas já tratam o erro com estado vazio.
// WebSocket do chat: sem equivalente no backend próprio. Só conecta se REACT_APP_CHAT_WS_URL estiver definida.
export const CHAT_WS_URL = process.env.REACT_APP_CHAT_WS_URL || '';

// Link de assinatura (navegação, não requisição). Configurável; padrão: raiz do próprio app.
export const PRO_URL = process.env.REACT_APP_PRO_URL || '/';

export const chamadaRemovida = () => Promise.reject(new Error('Fonte externa removida (FAT-33)'));
